import { createI18n } from 'vue-i18n'
import ro from './locales/ro'
import en from './locales/en'
import ru from './locales/ru'

const savedLang = localStorage.getItem('lang') || 'Ro'

const localeMap = {
  Ro: 'ro',
  En: 'en',
  Ru: 'ru'
}

export const i18n = createI18n({
  legacy: false,
  locale: localeMap[savedLang] || 'ro',
  fallbackLocale: 'ro',
  messages: { ro, en, ru },
  warnHtmlMessage: false
})

export default i18n
